export default __webpack_public_path__ + "static/media/TIGWeldingImg.d62cd42a.jpg";